<template>
  <div id="adults-bmi">

    <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-x-4 tw-gap-y-1">
      <b-form-group :label="$t('tools.height')" label-for="edit-height">
        <b-input-group :append="$t('tools.append.height')">
          <b-form-input id="edit-height" v-model="height"
                        :placeholder="$t('tools.bmi.placeholder.height')"
                        type="text"
                        v-decimal
          ></b-form-input>
        </b-input-group>
      </b-form-group>

      <b-form-group :label="$t('tools.weight')" label-for="edit-weight">
        <b-input-group :append="$t('tools.append.weight')">
          <b-form-input id="edit-weight" v-model="weight"
                        :placeholder="$t('tools.bmi.placeholder.weight')" type="text"
                        v-decimal
          ></b-form-input>
        </b-input-group>
      </b-form-group>

      <div class="lg:tw-col-span-2 tw-text-right">
        <b-button variant="primary" @click="calculate">{{ $t('tools.bmi.btn') }}</b-button>
      </div>

      <div v-if="bmi" class="lg:tw-col-span-2 tw-mt-2">
        <div class="tool-result" :class="`tool-result--${resultColor}`">
          <strong>{{ result }}</strong>
          <span class="text-muted tw-ml-2">{{ $t('tools.bmi.result.prefix') }}: {{ bmi.toFixed(1) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {bmiClass} from "@utils/bmi";

export default {

  data() {
    return {
      height: null,
      weight: null,
      bmi: null,
      result: null,
      resultColor: '',
      results: [0,1,2,3,4,5].map(x => this.$t(`tools.bmi.result.${x}`)),
      resultColors: ['warning', 'success', 'warning', 'danger', 'danger', 'danger'],
    }
  },

  methods: {
    calculate() {
      this.bmi = this.weight / Math.pow(this.height / 100, 2);
      const index = bmiClass(this.bmi);

      this.result = this.results[index];
      this.resultColor = this.resultColors[index];
    }
  }
}
</script>
